import React, { useEffect, useState } from 'react'
import Input from 'components/Input'
import PhoneNumberInput from 'components/PhoneNumberInput'
import { withTranslation } from 'react-i18next'
// import { useSelector } from 'react-redux'
import { filterValues } from 'Helper'
import useSWR from 'swr'
import { useFormContext } from 'react-hook-form'

const StepOneForm = ({ t }) => {
  const { data: Countries } = useSWR('collections/countries')
  const { data: Categories } = useSWR('collections/categories?page=1&page-size=500')

  const [countries, setCountries] = useState([])
  const [categories, setCategories] = useState(null)

  const [selectedCountry, setSelectedCountry] = useState('NG')

  const { watch, setValue } = useFormContext()

  useEffect(() => {
    if (Countries && Categories) {
      setCountries(Countries.data.filter(x => x.name === 'Ghana' || x.name === 'Nigeria'))
      setCategories(Categories.data)
    }
  }, [Countries, Categories]);

  const countryId = watch('country_id');
  useEffect(() => {
    setSelectedCountry(countries.find(x => x.id === countryId));
  }, [countryId, countries, watch]);

  const fields = [
    {
      name: 'name',
      label: t('registration.field.bname')
    },
    {
      name: 'primary_email',
      label: t('registration.field.bmail')
    },
    {
      name: 'country_id',
      placeholder: t('registration.field.country'),
      options: countries?.length ? filterValues({ options: countries, param: { value: 'id', label: 'name' } }) : []
    },
    {
      name: 'category_id',
      placeholder: t('registration.field.category'),
      options: categories?.length ? filterValues({ options: categories, param: { value: 'id', label: 'name' } }) : []
    },
    {
      name: 'primary_phone',
      label: t('registration.field.phone'),
    }
  ]
  return (
    <div className='flex flex-col gap-[12px] text-left'>
      {
        fields.map(field => {
          return (
            <div className="" key={field.name}>
              {
                field.name === 'primary_phone' ? (
                  <>
                    <PhoneNumberInput
                      name={field.name}
                      label={field.label}
                      country={selectedCountry?.iso2}
                      international
                      className={{ bodyClass: "bg-input w-full rounded-lg pl-2", inputClass: 'py-4 rounded-r-lg !bg-input' }}
                      singleInputClassName={'bg-input w-full rounded-lg pl-2 py-4'}
                      disabled
                      errorState={(data) => setValue('phoneError', data)}
                      labelwithin
                      code={selectedCountry?.phone_code}
                    />
                    <span className='text-[blue]'>{!watch('country_id') && 'must select a country first'} </span>
                  </>) : (
                  <Input
                    name={field.name}
                    label={field.label}
                    options={field?.options}
                    placeholder={field?.placeholder}
                    labelwithin={true}
                    classList='text-left'
                  />
                )
              }
            </div>
          )
        })
      }
    </div>
  )
}

export default withTranslation()(StepOneForm)